module.exports = __webpack_public_path__ + "static/banner-c36af1ef73e7fa147bed221f7732532d.png";